export class Enc {
	static shouldCrypt = false;
	static CryptoJS = require('crypto-js');

	static encryptWithAES = (text) => {
		const passphrase = '123';
		return Enc.CryptoJS.AES.encrypt(text, passphrase).toString();
	};
	static decryptWithAES = (ciphertext) => {
		const passphrase = '123';
		const bytes = Enc.CryptoJS.AES.decrypt(ciphertext, passphrase);
		const originalText = bytes.toString(Enc.CryptoJS.enc.Utf8);
		return originalText;
	};

	static encrypt = text => encodeURIComponent(Enc.encryptWithAES(text));
	static decrypt = data => Enc.decryptWithAES(decodeURIComponent(data));

	static XorMe = (text, key, encode = false) => {
		let encryptedSampleMessage = "";
		for (let i = 0; i < text.length; i++) {
			let charCode = text.charCodeAt(i) ^ key;
			encryptedSampleMessage += String.fromCharCode(charCode);
		}
		return encode ? encodeURIComponent(encryptedSampleMessage)
			: encryptedSampleMessage;
	}
}